// The Competitors page benchmarks one owned company against its own rivals.
// That set is derived from the company's CompetitorLink rows on every read
// rather than persisted: a stored set outlives the company it was built for,
// and a leftover entry from a previously selected company reads as a rival of
// the current one — while the current company itself goes missing from the
// stats, leaving the Snapshot cards with no `you` to compare against.
export function deriveBenchmarkSet(selectedCompany, companiesWatched) {
  if (!selectedCompany?.company_id) return [];
  const owner = (companiesWatched || []).find(
    (c) => String(c.company_id) === String(selectedCompany.company_id),
  );
  // Before the watched list loads there are no links to add, but "you" still
  // benchmarks against yourself — never an empty set that blanks the page.
  const you = {
    company_id: owner?.company_id ?? selectedCompany.company_id,
    company_name: owner?.company_name ?? selectedCompany.company_name,
  };
  return [
    you,
    ...(owner?.competitors || []).map((link) => ({
      company_id: link.company_id,
      company_name: link.name,
    })),
  ];
}
